import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HeightLogPage = lazy(() => import("./HeightLogPage"));

const HeightLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HeightLogPage />
    </Suspense>
  );
};

export default HeightLogPageLazy;
